import { render } from "./PedidosCartao.vue?vue&type=template&id=e1db1500&scoped=true"
import script from "./PedidosCartao.vue?vue&type=script&lang=js"
export * from "./PedidosCartao.vue?vue&type=script&lang=js"

import "./PedidosCartao.vue?vue&type=style&index=0&id=e1db1500&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1db1500"]])

export default __exports__